import classNames from "classnames";
import { ButtonProps } from "./Button";

export const buttonClasses = (
  opt: Pick<ButtonProps, "color" | "inverted" | "size">,
) =>
  classNames("rounded-md py-2 font-medium focus:outline-none max-w-xs border", {
    "py-1 px-2 text-xs": opt.size === "small",
    "py-2 px-4 font-medium": opt.size === "medium",
    "bg-white": opt.inverted,
    "text-primary": opt.inverted && opt.color === "primary",
    "border-primary text-white bg-primary":
      !opt.inverted && opt.color === "primary",
    "text-secondary": opt.inverted && opt.color === "secondary",
    "border-secondary text-white bg-secondary":
      !opt.inverted && opt.color === "secondary",
    "text-green-600": opt.inverted && opt.color === "success",
    "border-green-600 text-white bg-green-600":
      !opt.inverted && opt.color === "success",
  });

export const linkButtonClasses = () =>
  classNames(
    "bg-none border-none p-0 cursor-pointer no-underline text-primary font-inherit",
  );
